<template>
	<App title="Financiers">
		<Block>
			<template #header>
				<h3 class="block-title">Financiers</h3>
			</template>
			<Datatable :options="options" />
		</Block>
	</App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
	components: {
		App,
		Block,
		Datatable,
	},
})
class Group extends Vue {
	get buttons() {
		let buttons: any[] = []
		buttons.push('refresh')
		buttons.push({
			extend: 'create',
			attr: {
				href: this.route('financier.page.create'),
			},
		})
		buttons.push('trashed')

		return buttons
	}

	get columns() {
		let columns: any[] = []

		columns.push({
			data: 'id',
			orderable: true,
			name: 'id',
			title: 'Id',
		})
		columns.push({
			data: 'title',
			title: 'Title',
			
		})
		columns.push({
			data: 'email',
			title: 'Email',
			orderable: true,
			name: 'email',
		})
		columns.push({
			data: 'phone',
			title: 'Phone',
			orderable: true,
			name: 'phone',
		})
		// columns.push({
		// 	data: 'account.0.number',
		// 	title: 'Account Number',
	
		// 	orderable: true,
		// 	name: 'total_assets',
		// })

		columns.push({
			data: 'created_at',
			title: 'Date Created',
			render: CellRender.date(),
			orderable: true,
			name: 'created_at',
		})

		columns.push(Column.actions(this.$gate))

		return columns
	}

	get options() {
		return {
			ajax: {
				url: this.route('financier.ajax.table'),
				method: 'POST',
			},
			buttons: this.buttons,
			columns: this.columns,
		}
	}
}
export default toNative(Group)
</script>
